<script lang="ts">
	import { activeItem, loginOverlayIsVisible } from './stores/header';
</script>

<dialog
	open
	class="bg-beige p-10 top-0 left-[clamp(1rem,-4.4286rem+27.1429vw,20rem)] max-w-[min(100%,370px)] m-0 shadow"
>
	<p class="text-pretty">Bitte einloggen oder registrieren, um die Bilder sehen zu können</p>
	<div class="flex flex-wrap gap-3 mt-6">
		<button
			class="button text-sm py-3 px-4 leading-none"
			on:click={() => {
				$activeItem = 'Registrieren';
				$loginOverlayIsVisible = true;
			}}>Registrieren</button
		>
		<button
			class="button button-primary text-sm py-3 px-4 leading-none"
			on:click={() => {
				$activeItem = 'Login';
				$loginOverlayIsVisible = true;
			}}>Login</button
		>
	</div>
</dialog>
